import clsx from 'clsx';
import React, { memo, PropsWithChildren, useEffect, useRef } from 'react';

import { EmbeddedContentProps } from './EmbeddedContent.interface';
import useStyles from './EmbeddedContent.styles';

const EmbeddedContent = ({ content }: PropsWithChildren<EmbeddedContentProps>) => {
  const divRef = useRef<HTMLDivElement>(null);
  const classes = useStyles({});

  useEffect(() => {
    if (content && divRef.current) {
      /* Creating HTML Fragment */
      const slotHtml = document.createRange().createContextualFragment(content);
      divRef.current.innerHTML = '';
      divRef.current.appendChild(slotHtml);

      setTimeout(() => window.dispatchEvent(new CustomEvent('load')));
    }
  }, [content]);

  const rootClasses = clsx(classes.root, 'qa-embedded-content');
  // eslint-disable-next-line react/no-danger
  return <div className={rootClasses} ref={divRef} />;
};

export default memo(EmbeddedContent);
